import { z } from 'zod'
import { SessionSchema } from '../session.js'
import { UserSchema } from '../user.js'

export const PhotoLoginResponseSchema = z.object({
  session: SessionSchema,
  user: UserSchema,
})
export type PhotoLoginResponse = z.infer<typeof PhotoLoginResponseSchema>

// Issued by POST /api/auth/login-session for the cross-device QR-login flow.
// `login_url` is the frontend phone-login page; the desktop encodes that URL
// into a scannable QR. Anonymous-issued — no cookie required.
export const LoginSessionResponseSchema = z.object({
  login_token: z.string().min(1),
  login_url: z.string().url(),
  expires_at: z.string(),
})
export type LoginSessionResponse = z.infer<typeof LoginSessionResponseSchema>

// Polling response for GET /api/auth/login-session/:token. While the phone
// hasn't completed, returns `pending`. Once the phone has logged in, the
// response is `ready` AND carries a `Set-Cookie: srab_session=…` so the
// desktop's next request is authenticated. After expiry → `expired` + 410.
export const LoginSessionStatusResponseSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal('pending'), expires_at: z.string() }),
  z.object({
    status: z.literal('ready'),
    session: SessionSchema,
    user: UserSchema,
  }),
  z.object({ status: z.literal('expired') }),
])
export type LoginSessionStatusResponse = z.infer<
  typeof LoginSessionStatusResponseSchema
>
